import { STATUS_TAG_STATE } from '../constants';

export const calculateBarStatus = (step, currentStep) => {
  if (step < currentStep) return STATUS_TAG_STATE.FINISHED;
  if (step > currentStep) return STATUS_TAG_STATE.INACTIVE;
  return STATUS_TAG_STATE.ACTIVE;
};
